import { Box, Typography } from '@wishket/design-system';

const GrassColumnHeader = () => {
  return (
    <Box className="flex w-4 flex-col pt-[5px]">
      {['월', '수', '금'].map((day) => (
        <Typography key={day} variant="body2" className="text-w-gray-600">
          {day}
        </Typography>
      ))}
    </Box>
  );
};

export default GrassColumnHeader;
